import React from 'react';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import styles from './phone-input.module.css';

type PhoneNumberInputProps = {
  value: string;
  onChange: (value: string, data: CountryData | object) => void;
  error?: string;
  disabled?: boolean;
  country?: string;
};

export const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  error,
  disabled,
  country,
}) => {
  return (
    <div className={styles.phoneInputWrapper}>
      <PhoneInput
        disabled={disabled}
        country={country?.toLowerCase()}
        value={value || null}
        onChange={onChange}
        containerClass={styles.phoneInputContainer}
        inputClass={`${styles.phoneInput} ${error ? styles.errorField : ''}`}
        buttonClass={styles.flagButton}
        dropdownClass={styles.dropdown}
        excludeCountries={['ru']}
      />
    </div>
  );
};
